import { render, staticRenderFns } from "./Pensiones.vue?vue&type=template&id=48ea0190&"
import script from "./Pensiones.vue?vue&type=script&lang=js&"
export * from "./Pensiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports